module.exports = __webpack_public_path__ + "static/media/restart_icon.2dc9d234.svg";